<template>
    <div class="body">
      <div class="header">
        <el-form :model="SelectPieceworkCountDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="员工">
                    <el-input
                        v-model="SelectPieceworkCountDTO.operator"
                        placeholder=""
                    ></el-input>
                </el-form-item>
   
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button class="btn-style btn-buy"  type="warning" @click="downLoad">
              导出
            </el-button>
        </el-form>
      
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="计件详情" :visible.sync="dialogVisible"  width="60%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <div style="text-align: center;">
        <el-button class="btn-style btn-buy"   type="warning" @click="downLoadInfo" >
              导出
            </el-button>
          </div>
        <el-table
                        v-if="pieceworkCounts && pieceworkCounts.length"
                        :data="pieceworkCounts"
                        stripe
                        border
                        style="width: 100%"
              
                        class="pieceworkCounts"
                    >
                    <el-table-column
                            prop="orderName"
                            align="center"
                            label="订单名称"
                        ></el-table-column>
                        <el-table-column
                            prop="orderNumber"
                            align="center"
                            label="订单编号"
                        ></el-table-column>
                    <el-table-column
                            prop="category"
                            align="center"
                            label="产品种类"
                        ></el-table-column>
                        <el-table-column
                            prop="productionProcesses"
                            align="center"
                            label="工序"
                        ></el-table-column>
                        <el-table-column
                            prop="price"
                            align="center"
                            label="单价"
                        ></el-table-column>
                        <el-table-column
                            prop="area"
                            align="center"
                            label="面积"
                        ></el-table-column>
                        <el-table-column
                            prop="createTime"
                            align="center"
                            label="计件时间"
                        ></el-table-column>
        </el-table>
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <!-- <el-button  type="primary" @click="editAccount()">
            确 定
          </el-button> -->
        </el-form>
      </el-dialog>

      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          show-summary
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
  
        <el-table-column
            prop="operator"
            align="center"
            label="员工"
          ></el-table-column>
          <el-table-column
            prop="areas"
            align="center"
            label="计件米数"
          ></el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            label="计件工资"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">详情</el-link>
          </template>
        </el-table-column>

        </el-table>
      </div>
  

    </div>
  </template>
  
  <script>
  import { selectPieceworkCountByOperator,selectOperatorInfo,downLoadPieceworkCountByOperator,downLoadOperatorInfo} from '@/api/order/pieceCount.js'
  import { exportExcel } from '../../utils/index'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        SelectPieceworkCountDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            operator:'',
            productionProcesses:''
        },
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          name:'',
          price:'',
        },
        pieceworkCounts:[],
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
          name:[
                    { required: true, message: '请输入名称', trigger: 'blur' }]
           
            }

      }
    },
    
  
    mounted() {
      this.SelectPieceworkCountDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
        this.defaultDate()
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        console.log(row)
        this.SelectPieceworkCountDTO.operator=row.operator
        selectOperatorInfo(this.SelectPieceworkCountDTO).then((res) => {
         this.pieceworkCounts = res.data.data
        })
        this.dialogVisible = true
      },
      getTableData() {
        selectPieceworkCountByOperator(this.SelectPieceworkCountDTO).then((res) => {

          this.conTract = res.data.data
        })
      },
    

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        // 导出
        downLoad() {
          downLoadPieceworkCountByOperator(this.SelectPieceworkCountDTO)
          .then((res) => {
            if (res.status === 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      downLoadInfo(){
        downLoadOperatorInfo(this.SelectPieceworkCountDTO)
          .then((res) => {
            if (res.status === 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.SelectPieceworkCountDTO.startTime = e[0]
          this.SelectPieceworkCountDTO.endTime = e[1]
        } else if (!e) {
          this.SelectPieceworkCountDTO.startTime = ''
          this.SelectPieceworkCountDTO.endTime = ''
        }
      },
      defaultDate() {
      var date = new Date()
      var year = date.getFullYear().toString()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
      // var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
      var da = new Date(date.getFullYear(), month, 0).getDate()
      da < 10 ? '0' + da.toString() : da.toString()
      var start = year + '-' + month + '-01'
   
      this.SelectPieceworkCountDTO.startTime= new Date(start)
      const end = new Date()
     
      this.SelectPieceworkCountDTO.endTime= end
      this.date=[this.SelectPieceworkCountDTO.startTime,this.SelectPieceworkCountDTO.endTime]
     //将值设置给插件绑定的数据
     
    
    },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .btn-style{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  
.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.btn-buy{
    background: #FF8429;
}
  </style>
  